/**
 * "Built by Daatan" credit (owner request 2026-09-28), gold logo. On light backgrounds the transparent version
 * (brand/daatan-clear-*.webp — white removed with colour un-mixing); on the blue sidebar the white card version
 * (brand/daatan-*.webp — the dark gold letters would vanish into the navy without it).
 * Shown at the bottom of the login screen and of the sidebar / mobile menu.
 */
import { cn } from '@/lib/utils';

export function DaatanCredit({ width = 120, tone = 'light', className }: { width?: number; tone?: 'light' | 'dark'; className?: string }) {
  const file = tone === 'dark' ? 'daatan' : 'daatan-clear';
  return (
    <div className={cn('flex flex-col items-center gap-1.5', className)}>
      <span className={cn('text-[11px] tracking-wide', tone === 'dark' ? 'text-white/70' : 'text-muted')}>נבנה על ידי</span>
      <img
        src={`/brand/${file}-${width <= 160 ? 160 : 320}.webp`}
        srcSet={`/brand/${file}-160.webp 160w, /brand/${file}-320.webp 320w, /brand/${file}-480.webp 480w`}
        sizes={`${width}px`}
        width={width} height={Math.round(width * 491 / 784)}
        alt="דעתן — מהבנה לפתרון"
        loading="lazy" decoding="async"
        className="block h-auto select-none"
        draggable={false}
      />
    </div>
  );
}
